import { render, staticRenderFns } from "./XXLCheckbox.vue?vue&type=template&id=2a29ac34&scoped=true"
import script from "./XXLCheckbox.vue?vue&type=script&lang=js"
export * from "./XXLCheckbox.vue?vue&type=script&lang=js"
import style0 from "./XXLCheckbox.vue?vue&type=style&index=0&id=2a29ac34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a29ac34",
  null
  
)

export default component.exports